// extracted by mini-css-extract-plugin
export default {"cancelBuyOfferAvailableXlm":"RI4GdyegDlhy6c2n0Q8D","cancelBuyOfferConetent":"WfazVmK4q2GHW9PLmsC3"};